module.exports = __webpack_public_path__ + "img/header-weddingRingsGold@2x.5466de9.webp";